var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"aria-live":"assertive"}},[_c('transition',{attrs:{"name":"fade"}},[(_vm.visible)?_c('div',{staticClass:"AppSpinner",attrs:{"role":"alert","aria-busy":"true"}},[_c('v-progress-circular',{attrs:{"size":80,"indeterminate":""}})],1):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }